import React from 'react';
import { BarGraph, TRAIT_COLORS } from './DiscGraphs';

// A realistic, static sample of the personal DISC report an individual receives
// after taking the assessment. Shown on the Psychometrics page so buyers know
// exactly what they'll get. (Illustrative data — not a live result.)
const SAMPLE = { D: 68, I: 84, S: 41, C: 52 };

const Chip = ({ children, color = '#7FB08A', bg = '#EEF6F0' }) => (
  <span style={{ display: 'inline-block', padding: '0.28rem 0.6rem', borderRadius: 999, background: bg, color, fontSize: '0.72rem', fontWeight: 600 }}>{children}</span>
);

export function SampleDiscReport() {
  return (
    <div data-testid="sample-disc-report" style={{
      background: '#fff', border: '1px solid #ECE7DE', borderRadius: 24,
      boxShadow: '0 30px 60px -34px rgba(28,25,23,0.4)', overflow: 'hidden', maxWidth: 520,
    }}>
      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #0076A3 0%, #E39A3B 100%)', color: '#fff', padding: '1.1rem 1.4rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontSize: '0.66rem', textTransform: 'uppercase', letterSpacing: '0.14em', opacity: 0.85, fontWeight: 700 }}>Personal DISC Report</div>
            <div style={{ fontFamily: 'Cabinet Grotesk', fontSize: '1.15rem', fontWeight: 800, marginTop: 2 }}>Alex Morgan</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '0.66rem', opacity: 0.85 }}>Profile</div>
            <div style={{ fontFamily: 'Cabinet Grotesk', fontSize: '1rem', fontWeight: 800 }}>The Motivator</div>
            <div style={{ fontSize: '0.7rem', opacity: 0.9 }}>High I &middot; High D</div>
          </div>
        </div>
      </div>

      <div style={{ padding: '1.3rem 1.4rem' }}>
        {/* Sample watermark badge */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '0.4rem' }}>
          <Chip color="#B45309" bg="#FEF3C7">Sample report</Chip>
        </div>

        {/* Graph */}
        <BarGraph title="Your natural style" subtitle={'How you instinctively work, on a 0\u2013100 scale'} data={SAMPLE} testid="sample-disc-graph" />

        {/* Summary blurb */}
        <p style={{ fontSize: '0.84rem', color: '#44403C', lineHeight: 1.6, margin: '0.4rem 0 1rem' }}>
          You lead with energy and optimism, rally people around a goal, and move fast.
          You&rsquo;re at your best influencing, pitching and driving momentum &mdash; and you
          do your best work with autonomy and variety.
        </p>

        {/* Strengths */}
        <div style={{ marginBottom: '0.9rem' }}>
          <div style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.1em', color: '#78716C', fontWeight: 700, marginBottom: '0.4rem' }}>Strengths</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
            {['Persuasive communicator', 'Decisive under pressure', 'Builds rapport fast', 'Comfortable with change'].map((s) => (
              <Chip key={s}>{s}</Chip>
            ))}
          </div>
        </div>

        {/* Watch-outs + environment */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.9rem' }}>
          <div>
            <div style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.1em', color: '#78716C', fontWeight: 700, marginBottom: '0.35rem' }}>Watch-outs</div>
            <ul style={{ margin: 0, paddingLeft: '1rem', fontSize: '0.78rem', color: '#57534E', lineHeight: 1.55 }}>
              <li>May skip the detail</li>
              <li>Can commit too quickly</li>
            </ul>
          </div>
          <div>
            <div style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.1em', color: '#78716C', fontWeight: 700, marginBottom: '0.35rem' }}>Best environment</div>
            <ul style={{ margin: 0, paddingLeft: '1rem', fontSize: '0.78rem', color: '#57534E', lineHeight: 1.55 }}>
              <li>People-facing goals</li>
              <li>Freedom &amp; variety</li>
            </ul>
          </div>
        </div>

        {/* Legend */}
        <div style={{ display: 'flex', gap: '0.9rem', marginTop: '1.1rem', paddingTop: '0.8rem', borderTop: '1px solid #F1EDE8', flexWrap: 'wrap' }}>
          {['D', 'I', 'S', 'C'].map((t) => (
            <div key={t} style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', fontSize: '0.72rem', color: '#57534E' }}>
              <span style={{ width: 10, height: 10, borderRadius: 3, background: TRAIT_COLORS[t] }} />
              {{ D: 'Dominance', I: 'Influence', S: 'Steadiness', C: 'Conscientiousness' }[t]}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
